<div class="page-area">
    <div class="row">
        <div class="col-lg-12 col-sm-12 col-xs-12">
            <div class="tabledata">
                <div class="tabletop-description">
                    <div class="t-description">
                        <h5>Employee List</h5>
                        <a href="#">Print & Export</a>
                    </div>
                </div>
                <nz-table #fixedTable [nzData]="listOfData" [nzSize]="'small'">
                    <thead>
                        <tr>
                            <th>Emp-code</th>
                            <th>Employee Name</th>
                            <th>Shift Name</th>
                            <th>Department</th>
                            <th>Total emp.</th>
                            <th>Present</th>
                            <th>Absent</th>
                            <th>Pending shift</th>
                            <th>Designation</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of fixedTable.data" (dblclick)="open()">
                            <td>{{ data.name }}</td>
                            <td>{{ data.age }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                            <td>{{ data.address }}</td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </div>
</div>


<!-- employee master -->
<nz-drawer [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '0px' }"
    [nzMaskClosable]="false" [nzWidth]="'calc(100% - 27vh)'" [nzVisible]="visible"
    [nzTitle]=" (isEdit ? 'Update' : '') + ' ADD/Edit'" (nzOnClose)="close()">
        <div class="drawer-content">
            <div class="employee-tab">
                <div class="employee-menu">
                    <ul>
                        <li><a href="javascript:void();"><span></span> Save</a></li>
                        <li><a href="javascript:void();"><span></span> Clear</a></li>
                        <li><a href="javascript:void();"><span></span> Print Joint form</a></li>
                        <li><a href="javascript:void();"><span></span>Print Resign form</a></li>
                        <li><a href="javascript:void();"><span></span>Language</a></li>
                    </ul>
                </div>
                <nz-tabset nzType="card employee-card">
                    <nz-tab [nzTitle]="'General'">
                        <form class="general-box">
                            <div class="basic-boxes">
                                <div class="basic-details">
                                    <div class="basic-title">
                                        <h5>Basic Details</h5>
                                    </div>
                                    <div class="basic-contbox">
                                        <div class="emp-box">
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Emp Code</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Emp Code" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Ref. Code</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Ref. Code" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="emp-box">
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Punch ID</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Punch ID" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Name</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Name" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="emp-box">
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>First Name</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="First Name" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Surname</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Surname" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="emp-box">
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Gender</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <nz-radio-group [(ngModel)]="radioValue" [formControl]="name">
                                                        <label nz-radio nzValue="Male">Male</label>
                                                        <label nz-radio nzValue="Female">Female</label>
                                                      </nz-radio-group>
                                                </div>
                                            </div>
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Maritial status</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <nz-radio-group [(ngModel)]="radioValue" [formControl]="name">
                                                        <label nz-radio nzValue="Married">Married</label>
                                                        <label nz-radio nzValue="Unmarried">Unmarried</label>
                                                      </nz-radio-group>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="emp-box">
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Mobile Number</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Mobile Number" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Contact Number</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Contact Number" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="emp-box">
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Join Date</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Join Date" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Resign Date</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Resign Date" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="basic-details">
                                    <div class="basic-title">
                                        <h5>Personal Details</h5>
                                    </div>
                                    <div class="basic-contbox">
                                        <div class="emp-box">
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Birth Date</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Birth Date" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Blood Grp.</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Blood Grp." [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="emp-box">
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Anniversary</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Anniversary" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Birth Place</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Birth Place" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="emp-box">
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Father/Husband</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Father/Husband" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Grand Father</h5>
                                                </div>
                                                <div class="emp-input"> 
                                                    <input nz-input placeholder="Grand Father" [(ngModel)]="value"  [formControl]="name" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="emp-box">
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Identity Mark</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Identity Mark" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Religion</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Religion" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="emp-box">
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Cast</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Cast" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont">
                                                <div class="emp-title">
                                                    <h5>Sub Cast</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Sub Cast" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                        </div>
                                       
                                    </div>
                                </div>
                            </div>

                            <div class="basic-boxes">
                                <div class="basic-details basic-details2">
                                    <div class="basic-title">
                                        <h5>Present Address</h5>
                                    </div>
                                    <div class="basic-contbox">
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Present Address</h5>
                                            </div>
                                            <div class="emp-input">
                                                <textarea nz-input placeholder="Enter your present address" nzAutosize></textarea>
                                            </div>
                                        </div>
                                            <div class="basic-cont basic-cont2">
                                                <div class="emp-title">
                                                    <h5>City</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="City" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont basic-cont2">
                                                <div class="emp-title">
                                                    <h5>Taluko</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Taluko" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>

                                            <div class="basic-cont basic-cont2">
                                                <div class="emp-title">
                                                    <h5>District</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="District" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont basic-cont2">
                                                <div class="emp-title">
                                                    <h5>State</h5>
                                                </div>
                                                <div class="emp-input"> 
                                                    <input nz-input placeholder="State" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>

                                            <div class="basic-cont basic-cont2">
                                                <div class="emp-title">
                                                    <h5>Pin Code</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Pin Code" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>

                                    </div>
                                </div>

                                <div class="basic-details basic-details2">
                                    <div class="basic-title">
                                        <h5>Permanent Address</h5>
                                        <a href="javascript:void(0);" class="present-btn">Copy Present Address</a>
                                    </div>
                                    <div class="basic-contbox">
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Permanent Address</h5>
                                            </div>
                                            <div class="emp-input">
                                                <textarea nz-input placeholder="Enter your present address" nzAutosize [formControl]="name"></textarea>
                                            </div>
                                        </div>
                                            <div class="basic-cont basic-cont2">
                                                <div class="emp-title">
                                                    <h5>City</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="City" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont basic-cont2">
                                                <div class="emp-title">
                                                    <h5>Taluko</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Taluko" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>

                                            <div class="basic-cont basic-cont2">
                                                <div class="emp-title">
                                                    <h5>District</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="District" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont basic-cont2">
                                                <div class="emp-title">
                                                    <h5>State</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="State" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>

                                            <div class="basic-cont basic-cont2">
                                                <div class="emp-title">
                                                    <h5>Pin Code</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Pin Code" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>

                                    </div>
                                </div>

                                <div class="basic-details basic-details2">
                                    <div class="basic-title">
                                        <h5>Refrence Details</h5>
                                    </div>
                                    <div class="basic-contbox">
                                            <div class="basic-cont basic-cont2">
                                                <div class="emp-title">
                                                    <h5>Ref. Type</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Ref. Type" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont basic-cont2">
                                                <div class="emp-title">
                                                    <h5>Ref. Name</h5>
                                                </div>
                                                <div class="emp-input"> 
                                                    <input nz-input placeholder="Ref. Name" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>

                                            <div class="basic-cont basic-cont2">
                                                <div class="emp-title">
                                                    <h5>Ref. Contact</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Ref. Contact" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                            <div class="basic-cont basic-cont2">
                                                <div class="emp-title">
                                                    <h5>Ref. Address</h5>
                                                </div>
                                                <div class="emp-input">
                                                    <input nz-input placeholder="Ref. Address" [(ngModel)]="value" [formControl]="name" />
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </nz-tab>
                <nz-tab [nzTitle]="'Past Experience'">
                    <form class="general-box">
                        <div class="basic-boxes">
                            <div class="basic-details basic-details2">
                                <div class="basic-title">
                                    <h5>Add/Edit Details</h5>
                                </div>
                                <div class="basic-contbox">
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Left Company Name</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Left Company Name" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Com. Bussiness</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Com. Bussiness" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Worked as</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Worked as" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Work Duration</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Work Duration" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                    
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Reason for leave</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Reason for leave" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Remark</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Remark" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Owner Name</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Owner Name" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Address</h5>
                                            </div>
                                            <div class="emp-input">
                                                <textarea nz-input placeholder="Enter your address" nzAutosize></textarea>
                                            </div>
                                        </div>
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Contact No</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Mobile Number" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                </div>
                            </div>
                            <div class="basic-details basic-details3">
                                <div class="tabledata">
                                    <div class="tabletop-description">
                                        <div class="t-description">
                                            <h5>Employee List</h5>
                                            <a href="#">Print & Export</a>
                                        </div>
                                    </div>
                                    <nz-table #fixedTable [nzData]="listOfData2" [nzSize]="'small'">
                                        <thead>
                                            <tr>
                                                <th>Left Company Name</th>
                                                <th>Owner</th>
                                                <th>Company Bussiness</th>
                                                <th>Address</th>
                                                <th>Contact No.</th>
                                                <th>Worked As</th>
                                                <th>Work Duration</th>
                                                <th>Reason</th>
                                                <th>Remark</th>
                                                <th>Del</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let data of fixedTable.data">
                                                <td>{{ data.name }}</td>
                                                <td>{{ data.age }}</td>
                                                <td>{{ data.address }}</td>
                                                <td>{{ data.address }}</td>
                                                <td>{{ data.address }}</td>
                                                <td>{{ data.address }}</td>
                                                <td>{{ data.address }}</td>
                                                <td>{{ data.address }}</td>
                                                <td>{{ data.address }}</td>
                                                <td>{{ data.address }}</td>
                                            </tr>
                                        </tbody>
                                    </nz-table>
                                </div>
                            </div>
                        </div>
                    </form>
                </nz-tab>
                
                <nz-tab [nzTitle]="'Relative Details'">
                    <form class="general-box">
                        <div class="basic-boxes">
                            <div class="basic-details basic-details2">
                                <div class="basic-title">
                                    <h5>Add/Edit Details</h5>
                                </div>
                                <div class="basic-contbox">
                                    
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Relative Name</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Relative Name" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>City</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="City" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>

                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Relation</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Relation" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Contact No</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Contact No" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                    
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Occupation</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Occupation" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Address</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Address" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                    
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Del</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Del" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                    
                                </div>
                            </div>
                            <div class="basic-details basic-details3">
                                <div class="tabledata">
                                    <div class="tabletop-description">
                                        <div class="t-description">
                                            <h5>Employee List</h5>
                                            <a href="#">Print & Export</a>
                                        </div>
                                    </div>
                                    <nz-table #fixedTable [nzData]="listOfData2" [nzSize]="'small'">
                                        <thead>
                                            <tr>
                                                <th>Relative Name</th>
                                                <th>City</th>
                                                <th>Relation</th>
                                                <th>Contact No</th>
                                                <th>Occupation</th>
                                                <th>Address</th>
                                                <th>Del</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let data of fixedTable.data">
                                                <td>{{ data.name }}</td>
                                                <td>{{ data.age }}</td>
                                                <td>{{ data.address }}</td>
                                                <td>{{ data.address }}</td>
                                                <td>{{ data.address }}</td>
                                                <td>{{ data.address }}</td>
                                                <td>{{ data.address }}</td>
                                            </tr>
                                        </tbody>
                                    </nz-table>
                                </div>
                            </div>
                        </div>
                    </form>
                </nz-tab>

                <nz-tab [nzTitle]="'Education Details'">
                    <form class="general-box">
                        <div class="basic-boxes">
                            <div class="basic-details basic-details2">
                                <div class="basic-title">
                                    <h5>Add/Edit Details</h5>
                                </div>
                                <div class="basic-contbox">
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Qualification</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Qualification" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Name of Institution</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Name of Institution" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Result</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Result" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Passing Year</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Passing Year" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                    
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Del</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Del" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                    
                                </div>
                            </div>
                            <div class="basic-details basic-details3">
                                <div class="tabledata">
                                    <div class="tabletop-description">
                                        <div class="t-description">
                                            <h5>Employee List</h5>
                                            <a href="#">Print & Export</a>
                                        </div>
                                    </div>
                                    <nz-table #fixedTable [nzData]="listOfData2" [nzSize]="'small'">
                                        <thead>
                                            <tr>
                                                <th>Qualification</th>
                                                <th>Name of Institution</th>
                                                <th>Result</th>
                                                <th>Passing Year</th>
                                                <th>Del</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let data of fixedTable.data">
                                                <td>{{ data.name }}</td>
                                                <td>{{ data.age }}</td>
                                                <td>{{ data.address }}</td>
                                                <td>{{ data.address }}</td>
                                                <td>{{ data.address }}</td>
                                            </tr>
                                        </tbody>
                                    </nz-table>
                                </div>
                            </div>
                        </div>
                    </form>
                </nz-tab>
                <nz-tab [nzTitle]="'Relative In Company'">
                    <form class="general-box">
                        <div class="basic-boxes">
                            <div class="basic-details basic-details2">
                                <div class="basic-title">
                                    <h5>Add/Edit Details</h5>
                                </div>
                                <div class="basic-contbox">
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Relative Emp Name</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Relative Emp Name" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                        <div class="basic-cont basic-cont2">
                                            <div class="emp-title">
                                                <h5>Relation</h5>
                                            </div>
                                            <div class="emp-input">
                                                <input nz-input placeholder="Relation" [(ngModel)]="value" [formControl]="name" />
                                            </div>
                                        </div>
                                    
                                </div>
                            </div>
                            <div class="basic-details basic-details3">
                                <div class="tabledata">
                                    <div class="tabletop-description">
                                        <div class="t-description">
                                            <h5>Employee List</h5>
                                            <a href="#">Print & Export</a>
                                        </div>
                                    </div>
                                    <nz-table #fixedTable [nzData]="listOfData2" [nzSize]="'small'">
                                        <thead>
                                            <tr>
                                                <th>Relative Emp Name</th>
                                                <th>Relation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let data of fixedTable.data">
                                                <td>{{ data.name }}</td>
                                                <td>{{ data.age }}</td>
                                            </tr>
                                        </tbody>
                                    </nz-table>
                                </div>
                            </div>
                        </div>
                    </form>
                </nz-tab>
            </nz-tabset>
        </div>
    </div>
</nz-drawer>